import React, { FC, useState } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "./Grid.css";
import CompassTopicsWidget from "../CompassTopicsWidget/CompassTopicsWidget";
import ChatWidget from "../ChatWidget/ChatWidget";
import { useAuth } from "src/utils/hooks/UseAuth";
import GenerateSummaryWidget from "../GenerateSummaryWidget/GenerateSummaryWidget";
import CaseDocumentWidget from "../CaseDocumentWidget/CaseDocumentWidget";
import MyJrCtaWidget from "../MyJrCtaWidget/MyJrCtaWidget";

interface GridProps {
  data: any;
  onLayoutChange?: Function;
  onBreakpointChange?: Function;
}

const ResponsiveGridLayout = WidthProvider(Responsive);

type DynamicItem = { i: string } | null;

const Grid: FC<GridProps> = (props) => {
  const [counter, setCounter] = useState(0);
  const [dynamicItems, setDynamicItems] = useState<DynamicItem[]>([]);
  const [breakpoint, setBreakpoint] = useState<{
    breakpoint: {} | null;
    cols: number | null;
  }>({
    breakpoint: null,
    cols: null,
  });
  const [layout, setLayout] = useState<{ layout: {}[] | null }>({
    layout: [],
  });
  const { login, signup, logout } = useAuth();

  const layout_xs = [
    { i: "ChatWidget", x: 0, y: 0, w: 1, h: 2 },
    { i: "CompassTopicsWidget", x: 0, y: 0, w: 1, h: 2 },
    { i: "GenerateSummaryWidget", x: 0, y: 0, w: 1, h: 4 },
    { i: "CaseDocumentWidget", x: 0, y: 1, w: 2, h: 2 },
    { i: "MyJrCtaWidget", x: 1, y: 3, w: 1, h: 1, isResizable: false, resizeHandles: [] },
    // { i: "ChatInstructionsWidget", x: 0, y: 0, w: 1, h: 2 },
    // { i: "CaseSummaryWidget", x: 0, y: 0, w: 1, h: 3 },
    // { i: "CitationFormatsWidget", x: 1, y: 1, w: 1, h: 1 },
    // { i: "FilacWidget", x: 0, y: 2, w: 1, h: 2 },
    // { i: "CitationsChartWidget", x: 1, y: 2, w: 1, h: 2 },
    // { i: "FirstParagraphWidget", x: 0, y: 2, w: 1, h: 2 },
    // { i: "ReadingTimeWidget", x: 0, y: 3, w: 1, h: 1 },
    // { i: "CitationsComparisonChartWidget", x: 1, y: 4, w: 1, h: 2, isResizable: false, resizeHandles: [] },
    // { i: "ContentCaseRecommendationsWidget", x: 0, y: 0, w: 1, h: 2 },
    // { i: "LinkBasedCaseRecommendationWidget", x: 1, y: 0, w: 1, h: 2 },
  ];
  const layout_sm = [
    // { i: "ChatWidget", x: 0, y: 0, w: 2, h: 2 },
    { i: "CompassTopicsWidget", x: 0, y: 0, w: 2, h: 2 },
    { i: "GenerateSummaryWidget", x: 0, y: 0, w: 2, h: 4 },
    { i: "CaseDocumentWidget", x: 0, y: 1, w: 2, h: 2 },
    // { i: "MyJrCtaWidget", x: 1, y: 2, w: 2, h: 1, isResizable: false, resizeHandles: [] },
    // { i: "ChatInstructionsWidget", x: 1, y: 0, w: 1, h: 2 },
    // { i: "CaseSummaryWidget", x: 1, y: 0, w: 2, h: 2 },
    // { i: "ContentCaseRecommendationsWidget", x: 0, y: 0, w: 1, h: 2 },
    // { i: "LinkBasedCaseRecommendationWidget", x: 0, y: 0, w: 1, h: 2 },
    // { i: "CitationFormatsWidget", x: 0, y: 1, w: 1, h: 1 },
    // { i: "FilacWidget", x: 1, y: 0, w: 1, h: 2 },
    // { i: "CitationsChartWidget", x: 1, y: 0, w: 1, h: 2 },
    // { i: "FirstParagraphWidget", x: 1, y: 3, w: 1, h: 2 },
    // { i: "ReadingTimeWidget", x: 0, y: 2, w: 1, h: 1 },
    // { i: "CitationsComparisonChartWidget", x: 0, y: 5, w: 1, h: 2, isResizable: false, resizeHandles: [] },
  ];
  const layout_md = [
    // { i: "ChatWidget", x: 0, y: 0, w: 1, h: 2 },
    { i: "CompassTopicsWidget", x: 0, y: 0, w: 2, h: 2 },
    { i: "GenerateSummaryWidget", x: 2, y: 0, w: 1, h: 4 },
    { i: "CaseDocumentWidget", x: 0, y: 1, w: 2, h: 3 },
    // { i: "MyJrCtaWidget", x: 2, y: 3, w: 1, h: 1, isResizable: false, resizeHandles: [] },
    // { i: "ChatInstructionsWidget", x: 2, y: 0, w: 1, h: 2 },
    // { i: "CaseSummaryWidget", x: 0, y: 1, w: 2, h: 2 },
    // { i: "ContentCaseRecommendationsWidget", x: 2, y: 1, w: 1, h: 2 },
    // { i: "LinkBasedCaseRecommendationWidget", x: 1, y: 1, w: 1, h: 2 },
    // { i: "FilacWidget", x: 0, y: 2, w: 1, h: 2 },
    // { i: "CitationFormatsWidget", x: 0, y: 2, w: 1, h: 1 },
    // { i: "CitationsChartWidget", x: 1, y: 2, w: 1, h: 2 },
    // { i: "FirstParagraphWidget", x: 0, y: 4, w: 1, h: 2 },
    // { i: "CitationsComparisonChartWidget", x: 1, y: 4, w: 1, h: 2, isResizable: false, resizeHandles: [] },
    // { i: "ReadingTimeWidget", x: 0, y: 4, w: 1, h: 1 },
  ];

  const breakpoints = { md: 996, sm: 768, xs: 480 };

  const onWidthChange = (width: number) => {};

  const onBreakpointChange = (breakpoint: any, cols: any) => {
    setBreakpoint({
      breakpoint: breakpoint,
      cols: cols,
    });
  };

  const onLayoutChange = (layout: any) => {
    if (props.onLayoutChange) {
      props.onLayoutChange(layout);
    }
    setLayout({ layout: layout });
  };

  return (
    <>
      <ResponsiveGridLayout
        className="ResponsiveGrid"
        breakpoints={breakpoints}
        cols={{ md: 3, sm: 2, xs: 1 }}
        layouts={{ md: layout_md, sm: layout_sm, xs: layout_xs }}
        measureBeforeMount={true}
        useCSSTransforms={false}
        draggableHandle={".Card__Grip"}
        margin={[15, 15]}
        onLayoutChange={onLayoutChange}
        onBreakpointChange={onBreakpointChange}
        onWidthChange={onWidthChange}
      >
        {/* <div key="ChatWidget">
          <ChatWidget id={props.data._id} data={props.data}></ChatWidget>
        </div> */}
        <div key="CompassTopicsWidget">
          <CompassTopicsWidget id="compassTopicsWidget" data={props.data}></CompassTopicsWidget>
        </div>
        <div key="GenerateSummaryWidget">
          <GenerateSummaryWidget id={props.data._id} data={props.data}></GenerateSummaryWidget>
        </div>
        <div key="CaseDocumentWidget">
          <CaseDocumentWidget id={props.data._id} data={props.data}></CaseDocumentWidget>
        </div>
        {/* <div key="MyJrCtaWidget">
          <MyJrCtaWidget id="MyJrCtaWidget"></MyJrCtaWidget>
        </div> */}
        {/* <div key="ChatInstructionsWidget">
          <ChatInstructionsWidget />
        </div> */}
        {/* <div key="CaseSummaryWidget">
          <CaseSummaryWidget id={props.data._id} key={props.data._id}></CaseSummaryWidget>
        </div> */}
        {/* <div key="FirstParagraphWidget" className="Card">
          <FirstParagraphWidget id={props.data._id} key={props.data._id} />
        </div> */}
        {/* <div key="FilacWidget">
          <FilacWidget id={props.data._id} key={props.data._id}></FilacWidget>
        </div> */}
        {/* <div key="CitationsChartWidget">
          <CitationsChartWidget id="citationsChartWidget" data={props.data}></CitationsChartWidget>
        </div> */}
        {/* <div key="CitationsComparisonChartWidget">
          <CitationsComparisonChartWidget id="citationsComparisonChartWidget"></CitationsComparisonChartWidget>
        </div> */}
        {/* <div key="CitationFormatsWidget">
          <CitationFormatsWidget id="citationFormatsWidget" data={props.data}></CitationFormatsWidget>
        </div> */}
        {/* <div key="ContentCaseRecommendationsWidget">
          <ContentCaseRecommendationsWidget
            id="contentCaseRecommendationsWidget"
            data={props.data}
          ></ContentCaseRecommendationsWidget>
        </div> */}
        {/* <div key="LinkBasedCaseRecommendationWidget">
          <LinkBasedCaseRecommendationWidget
            id="linkBasedCaseRecommendationsWidget"
            data={props.data}
          ></LinkBasedCaseRecommendationWidget>
        </div> */}
        {/* <div key="ReadingTimeWidget">
          <ReadingTimeWidget id={props.data._id}></ReadingTimeWidget>
        </div> */}
      </ResponsiveGridLayout>
    </>
  );
};

export default Grid;
